<script setup lang="ts">
import AvatarChecked from '@/assets/icons/Avatars/AvatarChecked.vue';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const props = defineProps<{
  visible: boolean;
}>();

const { t } = useI18n();

const router = useRouter();
const emit = defineEmits<{
  'update:visible': [value: boolean];
}>();

const userStore = useUserStore();

const localVisible = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value),
});

// const currentSubscription = computed(() => {
//   return userStore.activeRestaurant?.subscription;
// });

// const trialDaysRemaining = computed(() => {
//   if (!currentSubscription.value?.trial_ends_at) return 0;

//   const trialEndDate = new Date(currentSubscription.value.trial_ends_at);
//   const today = new Date();
//   const diffTime = trialEndDate.getTime() - today.getTime();
//   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

//   return Math.max(0, diffDays);
// });

const handleAccept = async () => {
  await userStore.acceptTrialPopup();
  localVisible.value = false;
};
const goToSubscription = async () => {
  await userStore.acceptTrialPopup();
  localVisible.value = false;
  router.push({ name: 'subscription-plans' });
};

const trialDaysRemaining = computed(() => {
  const trialEndDate = userStore.activeRestaurant?.trial_ends_at;
  if (!trialEndDate) return 0;

  const endDate = new Date(trialEndDate);
  const today = new Date();
  const diffTime = endDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return Math.max(0, diffDays);
});
</script>

<template>
  <Dialog v-model:visible="localVisible" modal :closable="false" :style="{ width: '90vw', maxWidth: '500px' }" class="trial-popup">
    <template #header>
      <div class="flex items-center gap-2">
        <i class="pi pi-info-circle text-blue-500"></i>
        <span class="font-bold">{{ $t('subscription.trial.welcomeTitle') }}</span>
      </div>
    </template>

    <div class="my-4 flex flex-col gap-4">
      <AvatarChecked class="mx-auto mb-4 w-32" />
      <!-- <h3 class="mb-2 font-semibold text-lg">{{ $t('subscription.trial.welcomeTitle') }}</h3> -->
      <p class="text-gray-600">{{ $t('subscription.trial.message') }}</p>
      <p class="text-center font-semibold text-xl text-primary-900">
        {{
          t('subscription.trial.remainingDays', {
            days: trialDaysRemaining,
          })
        }}
      </p>

      <!-- Trial Information -->
      <!-- <div v-if="currentSubscription" class="rounded-lg border border-blue-200 bg-indigo-50 p-4">
        <div class="mb-3 text-center">
          <h4 class="mb-1 font-semibold text-blue-800">{{ currentSubscription.plan.name }}</h4>
          <div class="text-sm text-blue-600">
            <i class="pi pi-clock mr-1"></i>
            <span v-if="trialDaysRemaining > 0">
              {{ $t('subscription.trial.days_remaining', { days: trialDaysRemaining }) }}
            </span>
            <span v-else>
              {{ $t('subscription.trial.trial_ending_soon') }}
            </span>
          </div>
        </div> -->

      <!-- Plan Card -->
      <!-- <div class="flex items-center justify-center">
          <PlanCard v-if="currentSubscription.plan" :plan="currentSubscription.plan" show-features />
        </div> -->
      <!-- </div> -->

      <!-- Fallback features list if no subscription -->
      <!-- <div v-else class="rounded-lg bg-blue-50 p-4">
        <h4 class="mb-2 font-semibold text-blue-800">{{ $t('subscription.trial.features_included') }}</h4>
        <ul class="space-y-1 text-sm text-blue-700">
          <li class="flex items-center gap-2">
            <i class="pi pi-check text-green-500"></i>
            {{ $t('subscription.trial.feature_1') }}
          </li>
          <li class="flex items-center gap-2">
            <i class="pi pi-check text-green-500"></i>
            {{ $t('subscription.trial.feature_2') }}
          </li>
          <li class="flex items-center gap-2">
            <i class="pi pi-check text-green-500"></i>
            {{ $t('subscription.trial.feature_3') }}
          </li>
        </ul>
      </div> -->

      <!-- <div class="text-center">
        <p class="text-sm text-gray-500">{{ $t('subscription.trial.trial_duration') }}</p>
      </div> -->
    </div>

    <template #footer>
      <div class="flex w-full flex-row items-center justify-between gap-3">
        <Button :label="t('subscription.seeSubscriptions')" outlined @click="goToSubscription" />

        <Button :label="t('common.ok')" class="p-button-primary" icon="pi pi-check" @click="handleAccept" />
      </div>
    </template>
  </Dialog>
</template>
